<template>
    <modal size="lg" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Employer Match</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Plan: </span>{{ plan.display_name }}</div>
                </div>
            </div>

            <employer-match-form
                ref="employerMatchForm"
                :initial-value="plan"
            />
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import EmployerMatchForm from './EmployerMatchForm'

export default {
    props: ['client', 'plan', ],
    mixins: [FormMixin, ModalMixin],
    components: {EmployerMatchForm, },
    emits: ['updated', 'close', ],
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.plan.company_id)
        },
    },
    methods: {
        onSubmit() {
            if (!this.$refs.employerMatchForm.validate()) {
                this.formErrors = this.$refs.employerMatchForm.formErrors
                return
            }

            const data = this.$refs.employerMatchForm.getFormData()

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/deferred-comp-plans/${this.plan.id}/match-tiers`
            this.$api.put(url, data).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved employer match.`)
                this.$emit('updated')
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
